import { useCallback } from 'react';

import confirm from '../../helpers/confirm';

import useFormulaDraft from '../../hooks/formulas/useFormulaDraft';

export function useMoveToDraft({
    formulaId,
    isControlledFormula,
    isScheduledOrLiveFormula,
    onClose,
}: {
    formulaId: number;
    isControlledFormula?: boolean;
    isScheduledOrLiveFormula?: boolean;
    onClose: () => void;
}) {
    const draftFormula = useFormulaDraft(formulaId);

    const moveToDraftHandler = useCallback(async () => {
        let message = 'This will return your message to DRAFT mode.';
        if (isControlledFormula && isScheduledOrLiveFormula) {
            message =
                'This will cancel your scheduled message and move it to draft mode';
        }

        const confirmed = await confirm(message);
        if (confirmed) {
            draftFormula.mutate({});
            onClose();
        }
    }, [draftFormula, isControlledFormula, isScheduledOrLiveFormula, onClose]);

    return {
        moveToDraftHandler,
        isPending: draftFormula.isPending,
    };
}
